import { useMemo } from 'react';
import { useForm } from 'react-hook-form';

import { TableRowConfig } from '@repo/sdk/models/components';

import { buildBulkEditInitialValues } from '../equipment-bulk-edit.helpers';
import type { EquipmentBulkEditFormValues } from '../equipment-bulk-edit.types';

interface UseEquipmentBulkEditFormOptions {
  rows: TableRowConfig[];
}

interface UseEquipmentBulkEditFormReturn {
  form: ReturnType<typeof useForm<{ values: EquipmentBulkEditFormValues }>>;
}

export const useEquipmentBulkEditForm = ({
  rows,
}: UseEquipmentBulkEditFormOptions): UseEquipmentBulkEditFormReturn => {
  const initialValues = useMemo(() => buildBulkEditInitialValues(rows), [rows]);

  const form = useForm<{ values: EquipmentBulkEditFormValues }>({
    defaultValues: {
      values: initialValues,
    },
    mode: 'onChange',
  });

  return { form };
};
